<a href="https://www.focuspos.com/solutions/focuspay/" target="_blank">
	<div class="d-flex w-100">
		<div class="mx-auto text-center display-8">
			<img
				src="https://focuspos-onlineorder-images.s3.us-west-2.amazonaws.com/focuspay-logo.png"
				alt="FocusPay"
				class="img-fluid"
				width="auto"
				height="auto"
				style="max-height: 50px"
			/>
		</div>
	</div>
	<div class="d-flex w-100">
		<div class="mx-auto text-center display-8">This venue is not enabled for FocusPay</div>
	</div>
	<div class="d-flex w-100">
		<div class="mx-auto text-center display-8">Please contact your Focus Dealer for more inforamtion about FocusPay</div>
	</div>
</a>
